import RentsProfitsError from './RentsProfitsError';
import RentsProfits from './RentsProfits';
export default RentsProfits;
export { RentsProfitsError };
